import React, { Component } from "react";
import axios from "axios";
import { normalize } from "normalizr";

import i18n from "../../../../constants/i18n";
import createApiService from "../../../../network";
import { extractApiErrorMessage } from "../../../../helpers";
import { block as blockSchema } from "../../../../schemas";

import BlockPhotoProcessingFailureModalView from "./BlockPhotoProcessingFailureModalView";

class BlockPhotoProcessingFailureModalContainer extends Component {
    state = {
        isRemoving: false,
    };

    constructor(props) {
        super(props);

        this.api = createApiService(axios);
    }

    getFailedPhotos = () => {
        return this.props.block.photos.filter((photo) => photo?.processingFailure);
    };

    onRemoveFailedPhotos = async () => {
        const failedPhotos = this.getFailedPhotos();

        this.setState({ isRemoving: true });

        try {
            const failedPhotoIds = failedPhotos.map((photo) => photo.id);
            const imageIds = this.props.block.imageIds.filter(
                (imageId) => !failedPhotoIds.includes(imageId)
            );

            const {
                data: { data: block },
            } = await this.api.patchBlock(
                this.props.ceremonyId,
                this.props.block.id,
                { imageIds }
            );
            const updatedBlockEntities = normalize(block, blockSchema);
            this.props.updateStoreEntities(updatedBlockEntities.entities);

            const {
                data: { data: blocks },
            } = await this.api.getCeremonyBlocks(this.props.ceremonyId);
            const blockEntities = normalize(blocks, [blockSchema]);
            this.props.updateStoreEntities(blockEntities.entities);

            this.props.showToast({
                body: i18n.blockPhotoProcessingFailureModal.removeSuccess,
                title: "Success",
                themeClass: "is-success",
            });
            this.props.hideModal();
        } catch (e) {
            console.error(e);
            this.props.showToast({
                body: extractApiErrorMessage(e),
                title: "Error",
                themeClass: "is-danger",
            });
            this.setState({ isRemoving: false });
        }
    };

    render() {
        return (
            <BlockPhotoProcessingFailureModalView
                failedPhotos={this.getFailedPhotos()}
                hideModal={this.props.hideModal}
                isRemoving={this.state.isRemoving}
                isVisible={this.props.isVisible}
                onEditBlock={() => this.props.showBlockEditModal(this.props)}
                onRemoveFailedPhotos={this.onRemoveFailedPhotos}
            />
        );
    }
}

export default BlockPhotoProcessingFailureModalContainer;
